import axios, {
  AxiosInstance,
  AxiosResponse,
  AxiosRequestConfig
} from "axios";
import { API_URL } from "../constants";

class ApiService {
  client: AxiosInstance;

  constructor(base_api_url: string = API_URL) {
    this.client = axios.create({
      baseURL: base_api_url,
      timeout: 5000
    });
  }

  getToken() {
    let userData = JSON.parse(localStorage.getItem("auth") || "{}");
    if (userData && userData.token) {
      return userData.token;
    }
    return "";
  }

  setAuthHeader() {
    const token = this.getToken();
    if (!token) {
      console.error("no token in localstorage")
      return;
    }
    this.client.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }

  setAuthTokenFromRequest(token: string) {
    this.client.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }

  async get(path: string) {
    try {
      const response = await this.client.get(path);
      console.log("axios get: ", response);
      return response;
    } catch(err) {
      console.error("axios error: ", err);
    }
  }

  async query(path: string, params: AxiosRequestConfig) {
    const response = await this.client.get(path, params);
    console.log("axios query: ", response);
    return response;
  }

  post(path: string, data: any): Promise<AxiosResponse<any>> {
    const response = this.client.post(path, data, {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
    });
    return response;
  }

  postFormData(path: string, formData: string) {
    const response = this.client.post(path, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
    });
    console.log("axios post form data: ", response);
    return response;
  }

  put(path: string, data: string) {
    const response = this.client.put(path, data, {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
    });
    console.log("axios put: ", response);
    return response;
  }

  patch(path: string, data: string) {
    const response = this.client.patch(path, data, {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
    });
    console.log("axios patch: ", response);
    return response;
  }
}



axios.interceptors.response.use((response) => {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, (error) => {
  if (error.status === 401) {
    localStorage.removeItem("user_data");
    window.location.reload();
  }
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return Promise.reject(error);
});

export { ApiService };
